import { LocationModel } from '@cpd-app/core-module/models';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';

export const locationFeatureKey = 'location';

export const locationStateAdapter: EntityAdapter<OccupationQuickMatchModel> =
  createEntityAdapter<OccupationQuickMatchModel>({
    selectId: (occupationMicroModel: OccupationQuickMatchModel) =>
      occupationMicroModel.onetCode,
    sortComparer: false
  });

export interface LocationState extends EntityState<OccupationQuickMatchModel> {
  locationModel: LocationModel;
}

export const initialLocationState: LocationState =
  locationStateAdapter.getInitialState({
    locationModel: null
  });

export const { selectAll, selectEntities, selectIds, selectTotal } =
  locationStateAdapter.getSelectors();
